function roleArrayValidation(questionId, bankQuestionId) {

    return [
        {
            text: 'Relation/Role',
            value: 'placeholder',
            optionId: '1',
            disabled: true,
        },
        {
            text: 'Lender/Mortgagee',
            value: 'Lender/Mortgagee',
            optionId: '2',
            supplementalquestionIds:
            [bankQuestionId]
        },
        {
            text: 'Landlord',
            value: 'Landlord',
            optionId: '3'
        },
        {
            text: 'Municipality',
            value: 'Municipality',
            optionId: '4'
        },
        {
            text: 'Neighbour',
            value: 'Neighbour',
            optionId: '5'
        },
        {
            text: 'Parent Company',
            value: 'Parent Company',
            optionId: '6'
        },
        {
            text: 'Other',
            value: 'Other',
            optionId: '7',
            supplementalquestionIds:
            [questionId]
        }
    ];
}

export default roleArrayValidation;
